import { createStore } from 'owa-satcheljs';
import type { RepromptState } from './schema/RepromptState';

export const getRepromptStore: () => RepromptState = createStore<RepromptState>('repromptStore', {
    viewIndex: 0,
    showPrivacyRepromptDialog: false,
    showSettingsMigrationDialog: false,
    settingsRepromptCondition: undefined,
});
